<template>
    <div class="content">
        <div class="content-head">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="ERP订单号">
                    <el-input v-model="params.erpsn" placeholder="" style="width: 100px;" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="分支机构">
                    <el-input v-model="params.officename" placeholder="" clearable style="width: 100px;" class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="业务员">
                    <el-input v-model="params.slaemanename" placeholder="" clearable style="width: 100px;" class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="客户名称">
                    <el-input v-model="params.customername" placeholder="" style="width: 100px;" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="工程名称">
                    <el-input v-model="params.projectname" placeholder=""  style="width: 100px;" clearable class="el-select-medium"></el-input>
                </el-form-item>

                 <el-form-item label="逾期状态">
                    <el-select v-model="params.arstatus" placeholder="请选择" class="el-select-medium" style="width: 100px">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option v-for="item in ARStatusopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="getGSTAROrdersList(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh" :loading="loadingBtn">重置</el-button>
                </el-form-item>
                <!-- <el-form-item>
                    <el-button @click="setFiltration" :icon="!isFiltration ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">
                        {{ !isFiltration ? '展开' : '收起' }}
                    </el-button>
                </el-form-item> -->
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title">
                <span>欠款订单列表</span>
                <el-dropdown trigger="click">
                    <el-button type="primary">
                        导出
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <span @click="GetGSTAROrders_Export()">导出结果订单</span>
                        </el-dropdown-item>
                    </el-dropdown-menu> 
                </el-dropdown>
            </div>
            <el-table :data="tableData" ref="table" border :height="maxheight" style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn" :row-class-name="tableRowClassName" @row-click="handleRowClick">
                <el-table-column prop="AR_OrdersSN" label="ERP订单号"  show-overflow-tooltip align="center" width="120"></el-table-column>
                <el-table-column prop="AR_OfficeCode" label="分支机构" show-overflow-tooltip align="center" width="120"></el-table-column>
                <el-table-column prop="AR_OfficeManName" label="业务员" align="center" show-overflow-tooltip width="120"></el-table-column>
                <el-table-column prop="AR_CustomerName" label="客户名称" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="AR_ProjectName" label="工程名称" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="AR_Amount" label="应收欠款额" show-overflow-tooltip align="center" width="120">
                    <template slot-scope="scope">￥ {{ scope.row.AR_Amount }}</template>
                </el-table-column>
                <el-table-column prop="AR_Date" show-overflow-tooltip label="回款截止日期" align="center" width="120">
                    <template slot-scope="scope">
                        <span>{{ scope.row.AR_Date | formatDate }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
    </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue';
import { myMixin } from '@/utils/mixin.js';
import { cloneDeep } from 'lodash';
import { downloadFile, toLowerCaseKeys } from '@/utils/utils.js';
export default {
    name: 'aROrders',
    mixins: [myMixin],
    components: {
        Pagination
    },
    data() {
        return {
            loadingBtn: false,
            params: {},
            tableData: [],
            currentRow: null,
            ARStatusopt: [
                { label: '未逾期', value: 1 },
                { label: '已逾期', value: 2 }
            ],
        };
    },
    mounted() {
       
        this.onRefresh();
    },
    methods: {
        /*
    重置查询
    */
        onRefresh() {
            (this.params = {
                erpsn: '',
                officename: '',
                projectname: '',
                customername: '',
                slaemanename: '',
                arstatus: 0
            });
            // const paramsObj = this.$route.query || '';
            //   if (paramsObj) {
            //     if (paramsObj.arstatus) {
            //         this.params.arstatus = Number(paramsObj.arstatus);
            //     }
            // }
            this.getGSTAROrdersList(true);
        },

        /*
    列表查询
    */
        getGSTAROrdersList(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi
                .getGSTAROrdersList(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    } else {
                        this.tableData = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        filteropt() {
            let params = cloneDeep(this.params);
            return { json: JSON.stringify(toLowerCaseKeys(params)), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },

        GetGSTAROrders_Export() {
            this.$newsApi.getGSTAROrders_Export(this.filteropt()).then((res) => {
                if (res.data.Resultcode == 0) {
                    downloadFile(res.data.data, res.data.Resultinfo);
                }
            });
        },

        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getGSTAROrdersList();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getGSTAROrdersList();
        },
        /**
         * 表格行类名
         */
        tableRowClassName({row}) {
            if (this.currentRow && this.currentRow.AR_OrdersSN === row.AR_OrdersSN) {
                return "current-row";
            }
            return "";
        },
        /**
         * 点击行选中
         */
        handleRowClick(row) {
            this.currentRow = row;
        }
    }
};
</script>

<style>
.content-head {
    padding: 15px 20px 5px 20px;
}
.el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
.operation-bar {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    gap: 0px;
    white-space: normal;
}
.operation-bar-block {
    font-size: 12px;
    cursor: pointer;
    border-radius: 3px;
    margin: 1px 0;
}
</style>